import { UseFormReturn } from "react-hook-form";
import { GlassCard, GlassCardContent, GlassCardDescription, GlassCardHeader, GlassCardTitle } from "@/components/ui/glass-card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { FormField, FormItem, FormLabel, FormControl, FormDescription } from "@/components/ui/form";
import { Bell } from "lucide-react";
import { PatchPolicyFormValues } from "@/components/patching/schema";

interface NotificationSettingsSectionProps {
  form: UseFormReturn<PatchPolicyFormValues>;
}

export function NotificationSettingsSection({ form }: NotificationSettingsSectionProps) {
  return (
    <GlassCard variant="default" hover={false}>
      <GlassCardHeader>
        <GlassCardTitle className="flex items-center gap-2">
          <Bell className="h-5 w-5" />
          Notification Settings
        </GlassCardTitle>
        <GlassCardDescription>
          Manage how and when you receive notifications
        </GlassCardDescription>
      </GlassCardHeader>
      <GlassCardContent className="space-y-4">
        <FormField
          control={form.control}
          name="show_notifications"
          render={({ field }) => (
            <FormItem className="flex items-center justify-between rounded-lg border p-4">
              <div className="space-y-0.5">
                <FormLabel>Email Notifications</FormLabel>
                <FormDescription>
                  Receive email notifications for important events
                </FormDescription>
              </div>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <div className="flex items-center justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <Label>Browser Notifications</Label>
            <p className="text-sm text-muted-foreground">
              Show browser notifications for real-time updates
            </p>
          </div>
          <Switch defaultChecked />
        </div>

        <div className="flex items-center justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <Label>System Alerts</Label>
            <p className="text-sm text-muted-foreground">
              Get alerts for system issues and maintenance
            </p>
          </div>
          <Switch defaultChecked />
        </div>
      </GlassCardContent>
    </GlassCard>
  );
}
